import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const Settings = () => {
  const { role } = useAuth();

  // Redirect to role-specific settings
  if (role === 'customer') return <Navigate to="/settings" replace />;
  if (role === 'seller') return <Navigate to="/seller/settings" replace />;
  if (role === 'admin') return <Navigate to="/admin/settings" replace />;

  return <Navigate to="/login" replace />;
};

export default Settings;